import "./SearchTag.scss";
import PropTypes from "prop-types";

const SearchTag = (props) => {
  const handleClick = () => {
    if (!props.disabled && props.onClick) {
      props.onClick();
    }
  };

  return (
    <div
      id={props.id}
      className={` search-tag ${props.active ? "active" : ""}`}
      onClick={handleClick}
    >
      {props.value}
    </div>
  );
};

SearchTag.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default SearchTag;
